module.exports = __webpack_public_path__ + "static/media/A-millennials.07e64da9.png";